import React from 'react'

import './index.scss'
import { FaCheck } from 'react-icons/fa';

const WorkDone = ({ projectData }) => {
    let {
        workDone,
    } = projectData

    return workDone.map((role, index) => {
        return(
            <div key={index} className="role-container">
                <div className="role" key={index}>
                    <FaCheck className="role-dot" />
                    <div className="role-text">{role}</div>
                </div>
            </div>
        )
    })
}

export default WorkDone
